import { render, staticRenderFns } from "./send-coupon-add.vue?vue&type=template&id=54204278&scoped=true"
import script from "./send-coupon-add.vue?vue&type=script&lang=js"
export * from "./send-coupon-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54204278",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54204278')) {
      api.createRecord('54204278', component.options)
    } else {
      api.reload('54204278', component.options)
    }
    module.hot.accept("./send-coupon-add.vue?vue&type=template&id=54204278&scoped=true", function () {
      api.rerender('54204278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/components/sendcoupon/send-coupon-add.vue"
export default component.exports